export default {
  namespaced: true,
  state: () => ({
    mobileMenuOpen: false,
    loading: false,
    error: null,
  }),
  mutations: {
    TOGGLE_MENU(state) {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    CLOSE_MENU(state) {
      state.mobileMenuOpen = false;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
    SET_ERROR(state, val) {
      state.error = val;
    },
  },
  actions: {
    setLoading({ commit }, val) {
      commit("SET_LOADING", val);
    },
    setError({ commit }, val) {
      commit("SET_ERROR", val);
    },
  },
};
